import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { useEffect, useState, useRef } from 'react';
import { SignInStageEnum } from '../../../enums/SignInStage';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { UserActivateAccountRequest } from '../../../types/user';
import { useActivateUserAccount } from '../../../api/hooks/useUserQuery';
import { useNotificationContext } from '../../../contexts/NotificationContext';
import { getServerErrorMsg } from '../../../helpers/errorHandler';
import { OTPContextProvider } from '../../../contexts/OtpContext';
import SignInStagesSection from './SignInStagesSection';
import { Translations } from '../../../components/Translations/Translations';
import backgroundImage from '../../../assets/company/login-background.webp';

const SignInPage = () => {
  const { t } = useTranslation(['signIn', 'common', 'form']);
  const [signInStage, setSignInStage] = useState(SignInStageEnum.SIGN_IN);
  const [searchParams] = useSearchParams();
  const activateAccountMutation = useActivateUserAccount();
  const { successNotification, errorNotification } = useNotificationContext();
  const navigator = useNavigate();
  const hasActivatedRef = useRef(false);

  const onChangeState = (stage: SignInStageEnum) => {
    setSignInStage(stage);
  };

  useEffect(() => {
    if (hasActivatedRef.current) return;
    const tokenParam = searchParams?.get('token');
    if (tokenParam) {
      hasActivatedRef.current = true;
      let activateReq: UserActivateAccountRequest = {
        token: tokenParam,
      };

      activateAccountMutation.mutate(activateReq, {
        onSuccess: () => {
          successNotification(t('accountActivated'));
          navigator('/signIn');
        },
        onError: (response) => {
          let errorMsg = getServerErrorMsg(response);
          errorNotification(errorMsg);
          navigator('/signIn');
          //errorNotification()
        },
      });
    }
  }, []);

  return (
    <OTPContextProvider>
      <Row className="relative min-h-screen w-full" gutter={[0, 0]}>
        <Col
          xs={0}
          sm={0}
          md={12}
          style={{
            // backgroundImage: `url('/images/login-background.webp')`,
            backgroundSize: 'cover',
            backgroundPosition: 'left',
          }}
        >
          <div className="flex h-screen w-full flex-row items-center justify-center overflow-hidden bg-[#e4e4e4] text-3xl">
            <img
              src={backgroundImage}
              alt={t('loginBackgroundImage')}
              className="h-full w-full object-cover"
            />
          </div>
        </Col>
        <Col
          xs={24}
          sm={24}
          md={12}
          className="flex h-screen items-center justify-center px-6 py-10 sm:px-10 md:px-20"
        >
          <SignInStagesSection signInStage={signInStage} onChangeState={onChangeState} />
        </Col>
        <div className="absolute right-4 top-4 z-10 sm:right-8 sm:top-8">
          <Translations />
        </div>
      </Row>
    </OTPContextProvider>
  );
};

export default SignInPage;
